<ysh-button-control class="detail__close" type="exit" position="top-right" (click)="handleClose()"/>
<div class="detail">
  @if (loading) {
    <div class="detail__loading">
      <ysh-dots size="medium"/>
    </div>
  } @else if (delivery) {
    <header class="detail__header">
      <h2 class="detail__title">Event Delivery</h2>
      <ysh-badge [value]="delivery.status" [theme]="delivery.statusBadgeTheme"/>
    </header>

    <dl class="detail__meta">
      <div><dt>Event ID</dt><dd class="mono">{{ delivery.eventId }}</dd></div>
      <div><dt>Event Type</dt><dd>{{ delivery.eventType }}</dd></div>
      <div><dt>Response Status</dt><dd>{{ delivery.responseStatus ?? '—' }}</dd></div>
      <div><dt>Created</dt><dd>{{ delivery.createdAtFormatted }}</dd></div>
      <div><dt>Delivered</dt><dd>{{ delivery.deliveredAtFormatted }}</dd></div>
    </dl>

    @if (delivery.lastError) {
      <section class="detail__section">
        <h3 class="detail__section__title">Last Error</h3>
        <pre class="detail__code detail__code--error">{{ delivery.lastError }}</pre>
      </section>
    }

    @if (delivery.requestPayload != null) {
      <section class="detail__section">
        <h3 class="detail__section__title">Request Payload</h3>
        <pre class="detail__code">{{ delivery.requestPayloadPretty }}</pre>
      </section>
    }

    @if (delivery.responseBody) {
      <section class="detail__section">
        <h3 class="detail__section__title">Response Body</h3>
        <pre class="detail__code">{{ delivery.responseBody }}</pre>
      </section>
    }

    @if (delivery.responseHeaders != null) {
      <section class="detail__section">
        <h3 class="detail__section__title">Response Headers</h3>
        <pre class="detail__code">{{ delivery.responseHeadersPretty }}</pre>
      </section>
    }

    @if (delivery.isResendable) {
      <ysh-button
        class="detail__resend"
        label="Resend"
        icon="replay"
        theme="blue"
        [loading]="resending"
        [disabled]="resending"
        (click)="handleResend()"
      />
    }
  } @else {
    <p class="detail__empty">Delivery details are unavailable.</p>
  }
</div>
